import _taggedTemplateLiteral from "/usr/src/app/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import React from "react";
import Styled from "styled-components";
var RootWrapper = Styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
export var ModalRoot = function ModalRoot(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(RootWrapper, {
    id: "root-modal"
  }, children);
}; // array, bool, func, number, object, string
// symbol, node, element, elementType
// instanceOf oneOf oneOfType shape, exact, func, any

ModalRoot.propTypes = {};
ModalRoot.defaultProps = {
  onClick: function onClick() {
    return null;
  }
};